{
  "homeTitle": "Administration",
  "homeLead": "Offices, staff accounts and settings for the {lgu}.",
  "statusOk": "working",
  "statusNotConfigured": "not configured",
  "emergencyOnTitle": "Emergency mode is on",
  "emergencyOnSince": "Since {date}.",
  "manageEmergency": "Manage emergency mode",
  "setupNeededTitle": "Some services are not set up yet",
  "setupNeededBody": "The app works, but the items marked below are skipped until their keys are added to the server environment.",
  "systemTitle": "System status",
  "smsTitle": "SMS (responders, reminders)",
  "smsOk": "Sending through {provider}.",
  "smsMissing": "Not configured (SEMAPHORE_API_KEY). Texts are logged but not sent, and dispatchers see a warning.",
  "smsWeek": "Last 7 days: {sent} sent, {failed} failed, {skipped} not sent.",
  "mailTitle": "Email (verification, password reset, invites)",
  "mailOk": "Sending through {provider}.",
  "mailMissing": "Not configured (RESEND_API_KEY). Links are only printed in the server log — copy invite links from Staff accounts.",
  "pushTitle": "Push notifications",
  "pushOk": "Web Push is ready.",
  "pushMissing": "Not configured (VAPID keys). Residents can't turn on notifications. Generate keys with npm run keys:vapid.",
  "mapTitle": "Offline map",
  "mapOk": "A backup map extract is set, so the map works when OpenFreeMap is down or the phone is offline.",
  "mapMissing": "No backup map extract (MAP_FALLBACK_PMTILES_URL). The map needs OpenFreeMap to be reachable.",
  "countsTitle": "At a glance",
  "countOffices": "Active offices",
  "countStaff": "Active staff",
  "countInvited": "Invites not yet accepted",
  "countResidents": "Resident accounts",
  "countPosts": "Published posts",
  "countPending": "Posts waiting for approval",
  "countEmergency": "Open emergency reports",
  "countCrop": "Crop reports to validate",
  "countAudit": "Recorded actions (24 hours)",
  "linksTitle": "Manage",
  "linkOffices": "Offices",
  "linkOfficesHint": "Add offices, edit profiles, grant features.",
  "linkStaff": "Staff accounts",
  "linkStaffHint": "Invite staff, change roles, deactivate.",
  "linkSettings": "LGU settings",
  "linkSettingsHint": "App name, seal, accent colour, privacy contact.",
  "linkEmergency": "Emergency mode",
  "linkEmergencyHint": "Pin advisories and evacuation help to the top.",
  "linkHotlines": "Hotlines",
  "linkHotlinesHint": "Numbers residents can call, also offline.",
  "linkResponders": "Responder teams",
  "linkRespondersHint": "Who gets texted about emergency reports.",
  "linkDisasters": "Disaster events",
  "linkDisastersHint": "Group crop damage reports by typhoon or flood.",
  "linkCategories": "Categories",
  "linkCategoriesHint": "Topics residents filter and follow.",
  "linkAudit": "Audit log",
  "linkAuditHint": "Who changed what, and when.",
  "linkSms": "SMS log",
  "linkSmsHint": "Every text the app tried to send.",
  "officesTitle": "Offices",
  "officesLead": "Every municipal office and barangay that posts in the app. Add offices, edit their public profile, and choose which extra work screens each one can use.",
  "officesBaseNote": "Every office can post announcements, schedules and programs and manage registrations. The features you grant here are extra work screens on top of that.",
  "newOffice": "Add office",
  "createOffice": "Create office",
  "officeCreated": "{name} was created. Add its profile and features next.",
  "officeSaved": "Office saved.",
  "editOffice": "Edit {name}",
  "officeSections": "Office settings",
  "tabDetails": "Details",
  "tabProfile": "Profile",
  "tabFeatures": "Features",
  "officeName": "Office name",
  "officeShortName": "Short name",
  "officeShortNameHint": "Shown on posts and in menus, e.g. \"MDRRMO\".",
  "officeSlug": "Web name",
  "officeSlugHint": "Used in links: /offices/{slug}",
  "officeSlugHintEdit": "Used in links: /offices/{slug}. Changing it breaks links that were already shared.",
  "officeType": "Type",
  "type_municipal": "Municipal office",
  "type_barangay": "Barangay",
  "typePlural_municipal": "Municipal offices",
  "typePlural_barangay": "Barangays",
  "officeIcon": "Icon",
  "officeActive": "Active",
  "officeActiveHint": "Deactivated offices disappear from the app, their posts stop showing, and their staff can no longer open the workspace.",
  "confirmDeactivateOffice": "Deactivate {name}? It disappears from the app and its staff lose access to its workspace until you reactivate it.",
  "searchOffices": "Search offices",
  "showDeactivated": "Show deactivated",
  "noOffices": "No offices match.",
  "memberCount": "{count} staff",
  "updated": "updated {date}",
  "deactivated": "Deactivated",
  "profileLead": "This is the office's public page in the app: what it does, where it is and how to reach it. Office heads can edit it too.",
  "profileSaved": "Profile saved.",
  "saveProfile": "Save profile",
  "officeLogo": "Logo",
  "officeLogoHint": "Optional. Square PNG or JPG. Without a logo the icon is shown.",
  "officeDescription": "What the office does",
  "officeLocation": "Location",
  "officeHours": "Office hours",
  "officeHoursHint": "For example: Monday to Friday, 8:00 AM – 5:00 PM",
  "officePhone": "Phone",
  "officeEmail": "Email",
  "officeOtherContact": "Other contact",
  "officeOtherContactHint": "For example the office's Facebook page.",
  "featuresLead": "Choose the work screens {name} can use. Changes apply the next time its staff open the workspace.",
  "featuresSaved": "Features saved.",
  "saveFeatures": "Save features",
  "capBase": "Posts, schedules & registration",
  "capBaseHint": "Always on for every office.",
  "capLater": "Screen coming later",
  "cap_dispatch": "Emergency dispatch",
  "capHint_dispatch": "Live queue of emergency reports with responder SMS.",
  "cap_crop_damage": "Crop damage",
  "capHint_crop_damage": "Validate farmers' crop damage reports and export them for the DA.",
  "cap_evacuation": "Evacuation map",
  "capHint_evacuation": "Edit evacuation sites, occupancy, hazard areas and road closures.",
  "cap_tax": "Taxes",
  "capHint_tax": "Cedula and real property tax assessments.",
  "cap_civil_registry": "Civil registry",
  "capHint_civil_registry": "Birth, marriage and death certificate requests.",
  "cap_permits": "Permits",
  "capHint_permits": "Business and building permit applications.",
  "cap_queue": "Virtual queue",
  "capHint_queue": "Queue tickets with a live \"now serving\" display.",
  "cap_facilities": "Facilities booking",
  "capHint_facilities": "Bookings for gyms, halls and courts.",
  "cap_waste": "Waste & recycling",
  "capHint_waste": "Collection schedules and recyclables pickup.",
  "cap_tourism": "Tourism",
  "capHint_tourism": "Tourist spots, trails, guides and visitor registration.",
  "cap_market_prices": "Market prices",
  "capHint_market_prices": "Daily vegetable prices with trend charts.",
  "cap_emergency_mode": "Emergency mode",
  "capHint_emergency_mode": "Switch on the town-wide emergency banner during a disaster.",
  "cap_town_wide_urgent_alerts": "Urgent town-wide alerts",
  "capHint_town_wide_urgent_alerts": "Mark posts urgent so they reach every resident first.",
  "staffTitle": "Staff accounts",
  "staffLead": "Staff are invited by email and never sign up on their own. Deactivating an account signs the person out on every device at once.",
  "emailOffInvites": "Email is not configured, so invites are not emailed. After inviting someone, send them the invite link yourself: it appears here, or in the server log during development.",
  "inviteStaff": "Invite staff",
  "inviteLead": "Use the person's official office email. If they already have a staff account, they are added to the office instead.",
  "inviteEmailHint": "Resident accounts can't be turned into staff accounts.",
  "office": "Office",
  "chooseOffice": "Choose an office",
  "chooseOfficeError": "Choose the office this person works in.",
  "allOffices": "All offices",
  "role": "Role in this office",
  "roleIn": "Role in {office}",
  "roleHint_office_head": "Manages the office's staff and profile, and can do everything below.",
  "roleHint_editor": "Publishes posts and manages registrations.",
  "roleHint_contributor": "Drafts posts for an editor or head to approve.",
  "roleHint_viewer": "Can only look at registrations and reports.",
  "sendInvite": "Send invite",
  "inviting": "Sending…",
  "inviteSent": "Invite sent to {email}. The link works for 7 days.",
  "inviteNotEmailed": "{email} was invited, but email is not configured, so nothing was sent.",
  "inviteLogged": "{email} was invited. Email is not configured, so the invite link was printed in the server log (development only). Send it to them yourself.",
  "inviteAdded": "{email} already had a staff account and was added to {office}.",
  "inviteUpdated": "{email} is already in {office}; their role was updated.",
  "inviteLink": "Invite link",
  "inviteLinkHint": "Send this link to the person (for example by SMS or chat). It works for 7 days.",
  "copy": "Copy",
  "copyFailed": "Couldn't copy. Select the link and copy it by hand.",
  "inviteAnother": "Invite someone else",
  "addToOffice": "Add to an office",
  "searchStaff": "Name or email",
  "noStaff": "No staff accounts match.",
  "noNameYet": "Invite not yet accepted",
  "status_active": "Active",
  "status_invited": "Invited",
  "status_deactivated": "Deactivated",
  "administrator": "Administrator",
  "lastSignIn": "Last signed in {date}",
  "neverSignedIn": "Has not signed in yet",
  "noMemberships": "Not in any office.",
  "removeFromOffice": "Remove {name} from {office}",
  "confirmRemoveMembership": "Remove {name} from {office}? They lose access to that office's workspace right away.",
  "membershipRemoved": "Removed from the office.",
  "roleChanged": "{name} is now {role}.",
  "deactivate": "Deactivate",
  "reactivate": "Reactivate",
  "confirmDeactivate": "Deactivate {name}? They are signed out on every device immediately and can't sign in until you reactivate the account.",
  "confirmReactivate": "Reactivate {name}? They can sign in again with their existing offices and roles.",
  "deactivatedDone": "{name} was deactivated and signed out everywhere.",
  "reactivated": "{name} was reactivated.",
  "grantAdmin": "Make administrator",
  "revokeAdmin": "Remove administrator",
  "confirmGrantAdmin": "Make {name} a platform administrator? Administrators can change every office, staff account and setting.",
  "confirmRevokeAdmin": "Remove administrator access from {name}?",
  "adminGranted": "{name} is now an administrator.",
  "adminRevoked": "{name} is no longer an administrator.",
  "thisIsYou": "This is your account.",
  "settingsTitle": "LGU settings",
  "settingsLead": "How the app names and presents the LGU.",
  "settingsAppliesNote": "Changes apply right away for everyone: the app name on screen, the installed app, page titles, emails, SMS and share previews.",
  "identityTitle": "Name and seal",
  "displayName": "App name",
  "displayNameHint": "Shown as the app's name, e.g. \"Limitless La Trinidad\".",
  "lguName": "Official LGU name",
  "lguNameHint": "e.g. \"Municipality of La Trinidad\". Used in emails and on the About and Privacy pages.",
  "province": "Province",
  "tagline": "Tagline",
  "taglineHint": "One short line under the app name.",
  "seal": "LGU seal or logo",
  "sealHint": "Shown beside the iLi mark. Square PNG with a transparent background works best.",
  "sealSaved": "Seal updated.",
  "sealRemoved": "Seal removed.",
  "uploadImage": "Upload image",
  "replaceImage": "Replace image",
  "removeImage": "Remove",
  "uploading": "Uploading…",
  "brandTitle": "Accent colour",
  "accentTitle": "Accent colour",
  "accentLead": "Used for highlights and badges. Buttons and text stay Pine green so they are always easy to read.",
  "accentPicker": "Pick a colour",
  "accentHex": "Hex code",
  "accentReset": "Use the default",
  "accentInvalid": "Enter a colour like #C27638.",
  "accentRed": "Red is reserved for emergency buttons and urgent alerts. Choose another colour.",
  "accentNotRed": "Not red, so emergency buttons still stand out.",
  "accentOnWhite": "On white: {ratio} (needs {need} for icons and highlights).",
  "accentOnGround": "On the page background: {ratio} (needs {need}).",
  "accentBadgeText": "Badge text uses a darker shade: {ratio} (needs {need}).",
  "accentFix": "This colour doesn't pass the checks. Choose another one.",
  "dpoTitle": "Data Protection Officer",
  "dpoLead": "Shown on the privacy page (Data Privacy Act of 2012, RA 10173). Until it is filled in, the page shows a placeholder.",
  "dpoName": "Name",
  "dpoEmail": "Email",
  "dpoPhone": "Phone",
  "cropsTitle": "Crops",
  "cropsLabel": "Crops on the crop damage form",
  "cropsHint": "One crop per line, in the order farmers should see them. Keep \"Other\" last.",
  "cropsRequired": "Enter at least one crop.",
  "mapViewTitle": "Map view",
  "mapViewLead": "Where the map opens when someone first loads it.",
  "mapLat": "Latitude",
  "mapLng": "Longitude",
  "mapZoom": "Zoom (5–19)",
  "mapOutside": "Enter a point inside the LGU map area.",
  "mapZoomRange": "Zoom must be between 5 and 19.",
  "mapBounds": "The LGU map area runs from {w}, {s} to {e}, {n} (longitude, latitude). It is set in the config file because the offline map is cut from it.",
  "fixedTitle": "Set in the configuration file",
  "fixedLead": "These come from config/lgu.{slug}.json and change only with a new deployment.",
  "fixedSlug": "LGU code",
  "fixedAppId": "App ID",
  "fixedTimezone": "Time zone",
  "fixedPoweredBy": "Platform",
  "previewTitle": "Preview",
  "previewBadge": "Highlight",
  "previewOpen": "Registration open",
  "previewShare": "Shared link preview",
  "previewShareText": "{tagline}. Schedules, programs, registration and alerts from every office of the {lgu}.",
  "unsaved": "You have unsaved changes.",
  "lastSaved": "Last saved {date}",
  "discard": "Discard changes",
  "saveSettings": "Save settings",
  "settingsSaved": "Settings saved. Everyone sees the changes now.",
  "fixErrors": "Please fix the highlighted fields.",
  "categoriesTitle": "Categories",
  "categoriesLead": "Offices tag every post with a category. Residents filter and follow by category, in the order shown here.",
  "newCategory": "Add category",
  "editCategory": "Edit {name}",
  "noCategories": "No categories yet.",
  "categoryName": "Name",
  "categorySlug": "Web name",
  "categorySlugHint": "Used in links and filters. Lowercase letters, numbers and dashes.",
  "categoryIcon": "Icon",
  "categoryActive": "Active",
  "categoryActiveHint": "Inactive categories are hidden from filters and new posts. Existing posts keep their category.",
  "categorySaved": "Category saved.",
  "inactive": "Inactive",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "auditTitle": "Audit log",
  "auditLead": "Every staff and administrator action is recorded: who changed what, and when. Entries can't be edited or deleted.",
  "auditActor": "Who",
  "auditActorPlaceholder": "Name or email",
  "auditAction": "Action",
  "auditAnyAction": "Any action",
  "auditRecord": "Record",
  "auditAnyRecord": "Any record",
  "auditBy": "By",
  "auditSystem": "System",
  "auditOffice": "as {office}",
  "auditShowChanges": "Show what changed ({count})",
  "auditField": "Field",
  "auditBefore": "Before",
  "auditAfter": "After",
  "auditValue": "Value",
  "auditEmpty": "Nothing has been recorded yet.",
  "auditNoMatch": "No entries match these filters.",
  "clearFilters": "Clear filters",
  "smsLogTitle": "SMS log",
  "smsLogLead": "Every text message the app tried to send, including those not sent because SMS isn't configured.",
  "smsOffTitle": "SMS is not configured",
  "smsOffBody": "Messages are recorded here but not sent. Add SEMAPHORE_API_KEY to the server environment to start sending. Dispatchers see the same warning.",
  "smsLast7": "Last 7 days",
  "sms_sent": "Sent",
  "sms_failed": "Failed",
  "sms_not_configured": "Not sent (SMS off)",
  "smsSearch": "Number or text",
  "smsSearchPlaceholder": "0917 123 4567",
  "smsPurpose": "Purpose",
  "smsRelated": "About",
  "smsProvider": "Provider",
  "smsSentBy": "Sent by {email}",
  "smsError": "Error",
  "smsEmpty": "No text messages yet.",
  "smsNoMatch": "No messages match these filters.",
  "capElsewhere": "Handled in a separate app",
  "cap_transparency": "Transparency",
  "capHint_transparency": "Publish documents, bids and awards, and the officials directory.",
  "cap_ordinances": "Ordinances",
  "capHint_ordinances": "Track ordinances and resolutions from filing to approval.",
  "cap_community_moderation": "Community moderation",
  "capHint_community_moderation": "Review proposals and lost & found posts before they are public."
}
